module.exports = __webpack_public_path__ + "static/media/YM24_1.f3f6e3df.jpg";